/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: e50ad1ca57b4
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  AsyncUploadResponse,
  AsyncUploadResponse$zodSchema,
} from "./asyncuploadresponse.js";
import { UploadRequest, UploadRequest$zodSchema } from "./uploadrequest.js";
import {
  UploadResourceType,
  UploadResourceType$zodSchema,
} from "./uploadresourcetype.js";
import { UploadResponse, UploadResponse$zodSchema } from "./uploadresponse.js";

export type UploadGlobals = { cloud_name?: string | undefined };

export const UploadGlobals$zodSchema: z.ZodType<UploadGlobals> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type UploadRequestRequest = {
  resource_type?: UploadResourceType | undefined;
  upload_request: UploadRequest;
};

export const UploadRequestRequest$zodSchema: z.ZodType<UploadRequestRequest> = z
  .object({
    resource_type: UploadResourceType$zodSchema.default("auto").describe(
      "The type of resource (image, video, raw, or auto).",
    ),
    upload_request: UploadRequest$zodSchema.describe(
      "The file to upload and associated parameters.",
    ),
  });

/**
 * Successful upload
 */
export type UploadResponseBody = AsyncUploadResponse | UploadResponse;

export const UploadResponseBody$zodSchema: z.ZodType<UploadResponseBody> = z
  .union([
    AsyncUploadResponse$zodSchema,
    UploadResponse$zodSchema,
  ]).describe("Successful upload");

export type UploadResponseResponse =
  | ApiError
  | AsyncUploadResponse
  | UploadResponse
  | string;

export const UploadResponseResponse$zodSchema: z.ZodType<
  UploadResponseResponse
> = z.union([
  ApiError$zodSchema,
  z.union([
    AsyncUploadResponse$zodSchema,
    UploadResponse$zodSchema,
  ]),
  z.string().describe(
    "Redirect to callback URL (when 'callback' parameter is provided and request is not XHR).",
  ),
]);
